declare const window: any;

export const set = (key: string, data: any) => window.localStorage.setItem(key, JSON.stringify(data));

export const get = (key: string) => {
    const item = window.localStorage.getItem(key);
    if (item && item.length) {
        return JSON.parse(item);
    }
}
export const remove = (key: string) => window.localStorage.removeItem(key);


type tokenCacheObj = {
    data: {
        token: string,
        currency: string,
    },
    cartId: string,
    maxAge: number,
};

export const tokenCache = (key) => {
    return {
        key: key,
        maxAge: 24 * 60 * 60 * 1000, // ms
        isInfoValid: function (lsObj: tokenCacheObj | null = null, currCartId: string = '') {
            if (!lsObj || !lsObj.cartId || !lsObj.maxAge || !lsObj.data || // insufficient data
                lsObj.maxAge <= Date.now() || lsObj.cartId !== currCartId // check data validity
            ) return false;
            else return true;
        },
        get: function (currCartId: string) {
            try {
                const obj: tokenCacheObj = get(this.key) || null;
                if (this.isInfoValid(obj, currCartId)) return obj.data;
                else {
                    remove(this.key);
                    return null;
                }
            } catch (err) {
                console.error(err);
            }
        },
        set: function (data: tokenCacheObj['data'], cartId: string) {
            try {
                const obj: tokenCacheObj = {
                    data,
                    cartId,
                    maxAge: Date.now() + this.maxAge,
                };
                set(this.key, obj);
            } catch (err) {
                console.error(err);
            }
        }
    }
};

type adyenComponentSessionDataCacheObj = {
    data: {
        id: string,
        sessionData: string,
    },
    cartId: string,
    version: number,
    maxAge: number,
};

export const adyenComponentSessionDataCache = {
    key: '__adyen_component_session__',
    maxAge: 60 * 60 * 1000, // ms
    isInfoValid: function (lsObj: adyenComponentSessionDataCacheObj | null = null, currCartId: string = '', version: number) {
        if (!lsObj || !lsObj.cartId || !lsObj.maxAge || !lsObj.version || !lsObj.data || // insufficient data
            lsObj.maxAge <= Date.now() || lsObj.cartId !== currCartId || lsObj.version !== version // check data validity
        ) return false;
        else return true;
    },
    get: function (currCartId: string, version: number) {
        try {
            const obj: adyenComponentSessionDataCacheObj = get(this.key) || null;
            if (this.isInfoValid(obj, currCartId, version)) return obj.data;
            else {
                remove(this.key);
                return null;
            }
        } catch (err) {
            console.error(err);
        }
    },
    set: function (data: adyenComponentSessionDataCacheObj['data'], cartId: string, version: number) {
        try {
            const obj: adyenComponentSessionDataCacheObj = {
                data,
                cartId,
                version,
                maxAge: Date.now() + this.maxAge,
            };
            set(this.key, obj);
        } catch (err) {
            console.error(err);
        }
    }
};
